// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__DtOGB","searchIcon":"SearchBar_searchIcon__1fDOR"};